import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { ToasterService } from 'angular2-toaster';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/throw';
import { Router } from '@angular/router';
import { map, filter } from 'rxjs/operators';
import { ToasterAlertService } from '../../shared-component/notification/toastAlert.service';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {
  constructor(
    private router: Router,
    private toasterService: ToasterAlertService
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let passErrorBack = false;
    let requestClone = request.clone();

    if (request.headers.has('passErrorBack')) {
      passErrorBack = true;
      requestClone = request.clone({
        headers: requestClone.headers.delete('passErrorBack')
      });
    }

    let token = sessionStorage.getItem('token'), headers = {};
    if (token) {
      headers = {
        headers: requestClone.headers.set('Authorization', token)
      };
    }

    const ignoreShowingErrorPopups = (url = '') => {
      const listOfURLSNotToShowError = [
        environment.GET_PUBLIC_IP_URL
      ];
      return listOfURLSNotToShowError.indexOf(url) >= 0;
    }

    return next.handle(request.clone(headers)).pipe(
      filter(response => response instanceof HttpResponse),
      map(
        (res: HttpResponse<any>) => {
          // try {
          //   if (res && res.body && !res.body.safe) {
          //     const bytes = this.decrypt(res.headers.get('X-Parse-Token') || "techfino-server", res.body.data);
          //     res.body.data = JSON.parse(bytes.replace(/[^\x20-\x7E]/g, ""));
          //   }
          // } catch (err) {
          //   res.body.data = null;
          // }
          try{
            if(JSON.parse(localStorage.getItem('debug') || "false") == true){
              console.log(res.url,"\n",res.body.data);
            }
          }catch(JsonError){}
          return res;
        }
      )).catch((err) => {
        if (ignoreShowingErrorPopups(request.url)) {
          return Observable.empty();
        }
        if (err instanceof HttpErrorResponse && err.error.message) {
          if (err.error.logout === true) {
            sessionStorage.removeItem('token');
            this.router.navigate(['/authentication']);
            return Observable.empty();
          }
          if (err.error.errorType === 'GENERIC') {
            if (request.url.includes('loanApplication') && request.method === 'GET') {
              return Observable.throwError(err);
            } else if (request.url.includes('verify') && request.method === 'GET') {
              return Observable.throwError(err.error);
            }
            
            this.toasterService.pop('error', 'Alert', err.error.message);
            if (passErrorBack) {
              return Observable.throwError(err);
            }
            return Observable.empty();
          }
          if (err.error.errorType === 'VALIDATION') {
            if (request.url.includes('loanApplication') && request.method === 'GET') {
              return Observable.throwError(err);
            }
            return Observable.throwError(err.error.errorMessages);
          }
        }

        if (!navigator.onLine) {
          this.toasterService.pop('error', 'Alert', 'No Internet Connection');
          return Observable.empty();
        }

        this.toasterService.pop('error', 'Alert', err.error.message || err.error.detail || 'Oops! something went wrong');
        return Observable.empty();
      });
  }

  decrypt(salt, encoded) {
    if (!encoded) return null;
    const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
    const applySaltToChar = (code) => textToChars(salt).reduce((a, b) => a ^ b, code);
    return encoded
      .match(/.{1,2}/g)
      .map((hex) => parseInt(hex, 16))
      .map(applySaltToChar)
      .map((charCode) => String.fromCharCode(charCode))
      .join("");
  }
}
